import _ from "lodash";
import api from "api/api";

export const getJobList = async (profile) => {
  if (!_.isNil(profile)) {
    return await api.get(`/settings/jobs?profile=${profile}`);
  } else {
    return await api.get(`/settings/jobs`);
  }
};

export const createJob = async (data) => await api.post("/settings/jobs", data);

export const getJobById = async (id) => await api.get(`/settings/jobs/${id}`);

export const updateJobById = async (id, data) =>
  await api.put(`/settings/jobs/${id}`, data);

export const deleteJobById = async (id) =>
  await api.delete(`/settings/jobs/${id}`);
